import PageDataSet from '@/modules/app/store/pageDataSet'

export default class AppState {
  submitProtection = false
  loadingData: Array<string> = []
  pageDataSet: PageDataSet = new PageDataSet()
}
